import React, { Fragment, useState, useRef, useEffect } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { addReaction, addPostComment } from "../../../actions/post";
import FontAwesomeIcon from "../IME/Icon";
import ToggleButton from "../../PlayerButtons/ToggleButton";
import Volume from "../Employers/Volume";
import Progress from "../Employers/Progress";

import { evaluate } from "../../../utilities/props";

import CompanyCommentsItem from "./CompanyCommentsItem";

const CompanyPostItem = ({
  addReaction,
  post: {
    _id,
    text,
    avatar,
    image,
    video,
    companyname,
    location,
    likes,
    comments,
    date,
  },
  time,
  videoduration,
  addCompanyPostComment,
}) => {
  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showComments, setShowComments] = useState(false);
  const [comment, setComment] = useState("");

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);
  return (
    <Fragment>
      <div className="profile-post">
        <div className="post-top-container">
          <div className="post-type blue">Post</div>
          <div className="post-date">
            <i className="far fa-clock mr-5 mt-2 blue"></i>
            <Moment format="MM/DD/YYYY">{date}</Moment>
            <i className="fas fa-ellipsis-v fa-lg post-info blue"></i>
          </div>
        </div>
        <div className="post-header">
          <div className="online-avi-container">
            <div className="avi-color-border blue">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                className="drop-down-result-avi"
              />
            </div>
          </div>
          <div className="online-info">
            <ul className="user-online-items">
              <li className="user-online-item">
                <span className="blue name-font">{companyname}</span>
              </li>
              <li className="side-container-user-item">{location}</li>
            </ul>
          </div>
          <div></div>
        </div>
        {image && (
          <img
            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_images/${image}`}
            className="post-body post-image"
          />
        )}
        {video && (
          <div className="post-body">
            <div className="video-view">
              <div className="user-overlay">
                <div className="left-controls">
                  <ul className="controls">
                    <Volume
                      className="Rac__volume"
                      initial={0}
                      onChange={(level) => {
                        const volume = level / 100;
                        videoRef.current.volume = volume;
                        videoRef.current.muted = volume === 0;
                      }}
                    />
                  </ul>
                </div>
                <ToggleButton
                  className="center-controls"
                  value={() => videoRef.current && !videoRef.current.paused}
                  onChange={(active) => {
                    if (!active) {
                      return videoRef.current.pause();
                    }

                    return videoRef.current.play();
                  }}
                >
                  {(active) => {
                    if (currentTime > 0.1 && currentTime < duration && active) {
                      return (
                        <FontAwesomeIcon
                          onClick={(e) => videoRef.current.pause()}
                          icon="pause"
                          size="2x"
                          className="blue"
                        />
                      );
                    }
                    if (currentTime === duration) {
                      setCurrentTime(0);
                    } else if (currentTime === 0 && !active) {
                      return (
                        <FontAwesomeIcon
                          onClick={(e) => videoRef.current.play()}
                          icon="play"
                          size="2x"
                          className="blue"
                        />
                      );
                    }
                    return (
                      <FontAwesomeIcon
                        onClick={(e) => videoRef.current.play()}
                        icon="play"
                        size="2x"
                        className="blue"
                      />
                    );
                  }}
                </ToggleButton>
                <Progress
                  className="Rac__progress-bar"
                  initial={0}
                  time={currentTime}
                  duration={duration}
                  onSkip={(time) => (videoRef.current.currentTime = time)}
                />
              </div>
              <video
                ref={videoRef}
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_videos/${video}`}
                className="radius fill-video"
              ></video>
            </div>
          </div>
        )}
        <div className="header-container">
          <div className="post-text">{text}</div>
        </div>
        <div className="post-footer-alt">
          <div className="post-footer-icons">
            <ul className="footer-icons">
              <li className="footer-icon">
                <i
                  className="far fa-thumbs-up fa-lg blue"
                  onClick={() => addReaction(_id)}
                ></i>
                <span className="footer-icon-text">
                  {likes.length > 0 && <span>{likes.length}</span>}
                </span>
                <i className="far fa-thumbs-down fa-lg blue"></i>
              </li>
              <li
                className="footer-icon"
                onClick={(e) => setShowComments(true)}
              >
                <i className="far fa-comment fa-lg blue"></i>
                {comments.length > 0 && (
                  <span className="footer-icon-text">{comments.length}</span>
                )}
              </li>
            </ul>
          </div>
          {showComments && (
            <div className="profile-comments">
              <p className="hide-comments">
                <i
                  className="fas fa-comment-slash fa-lg mx-5 blue cursor"
                  onClick={(e) => setShowComments(false)}
                ></i>
                <span
                  className="white cursor"
                  onClick={(e) => setShowComments(false)}
                >
                  Hide Comments
                </span>
              </p>
              <div className="comment-reply-input-container-alt">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    addPostComment({ comment, _id });
                    setComment("");
                  }}
                  className="comment-reply-input-hidden"
                >
                  <input
                    type="text"
                    className="comment-reply-input"
                    name="comment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Enter your comment here..."
                  />
                  <button className="comment-reply-input-button background-blue">
                    <i className="far fa-comments"></i>
                  </button>
                </form>
              </div>
              {comments.map((comment) => (
                <CompanyCommentsItem
                  key={comment._id}
                  comment={comment}
                  id={_id}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

CompanyPostItem.propTypes = {
  post: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  addCompanyLike: PropTypes.func.isRequired,
  addPostComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  comment: state.comment,
  reply: state.reply,
});

export default connect(mapStateToProps, {
  addReaction,
  addPostComment,
})(CompanyPostItem);
